// extracted by mini-css-extract-plugin
export default {"root":"IconCloud_root__VttWg"};